import { contentStyles } from "../Content";

const legalContentStyles = {
  ...contentStyles,
  heading: {
    ...contentStyles.heading,
    counterIncrement: "orderedlist",
  },
  list: {
    ...contentStyles.list,
    listStyle: "none",
    li: { counterIncrement: "clause", position: "relative" },
    "li::before": {
      content: "counter(orderedlist) '.' counters(clause, '.')",
      fontSize: "lg",
      color: "primary.500",
      float: "left",
      mr: 2,
    },
    "li > p": {
      ml: 0,
    },
    "li > p:last-of-type": {
      mb: 8,
    },
    "li > ol > li": {
      counterIncrement: "subClause",
      ml: 5,
    },
    "li > ol > li::before": {
      content: "counter(orderedlist) '.' counters(clause, '.') '.' counters(subClause, '.')",
    },
    "li > ol > li > ol > li": {
      counterIncrement: "subClause2",
    },
    "li > ol > li > ol > li::before": {
      content: "counter(orderedlist) '.' counters(clause, '.') '.' counters(subClause, '.') '.' counters(subClause2, '.')",
    },
    "li > ol > li > ol > li > ol > li": {
      counterIncrement: "subClause3",
    },
    "li > ol > li > ol > li > ol > li::before": {
      content: "counter(orderedlist) '.' counters(clause, '.') '.' counters(subClause, '.') '.' counters(subClause2, '.') '.' counters(subClause3, '.')",
    },
  },
};

export default legalContentStyles;
